var map = {
	"./1.png": "60e1",
	"./2.png": "c853",
	"./3.png": "62be",
	"./4.png": "b99b",
	"./5.png": "c869",
	"./Marigold.png": "72e4",
	"./OrangeMarigold.png": "d92d",
	"./PurpleCarnation.png": "d60a",
	"./Redcarnation.png": "0ebd",
	"./WhiteCarnationfade.png": "380a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a5b9";